import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../../auth/guard.ts'
import { NAV_PATHS } from '../../navigation/paths.ts'
import { officialPlayersRoute } from './players.tsx'

// The address that opens «Aggiungi giocatore»: a child of the list, so the list stays mounted
// under the Panel and the search params and the data are the list's own.

export const officialNewPlayerRoute = createRoute({
  getParentRoute: () => officialPlayersRoute,
  path: 'new',
  // The list's guard has run already; `guards.test.ts` wants every route to say its own.
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['club'],
      currentPath: location.href,
    }),
  // The list under the Panel is still the page: the leaf decides what the shell reserves above it.
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../../pages/official/new-player.tsx')),
})

export const officialNewPlayerLink = { to: NAV_PATHS.officialNewPlayer } as const
